import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import React from 'react';
import { FieldGroupLabel, type FieldGroupLabelType } from '@/app/components/forms/field-group/label';
import { FieldGroupMessage, type FieldGroupMessageType } from '@/app/components/forms/field-group/message';
import { type CustomFormStyleConfig } from '@/app/components/forms/styles';
import { cn } from '@/app/utils/cn';
export interface FieldGroupErrorType {
  /**
   * (Optional) Error state
   */
  error?: boolean;
  /**
   * (Optional) Error message when error state = true
   */
  errorMessage?: string;
}
interface FieldGroupDisabledType {
  /**
   * (Optional) Disabled state
   */
  disabled?: boolean;
}
export interface FieldGroupType extends FieldGroupDisabledType, FieldGroupErrorType, FieldGroupLabelType, FieldGroupMessageType {
  ref?: React.Ref<any>;
}
export type InputType = 'input' | 'control';
interface FieldGroupProps extends FieldGroupType {
  inputType?: InputType;
  children?: ReactNode;
  /**
   * To override form group styling by using tailwind css
   */
  className?: string;
  /**
   * Custom theme styling
   */
  customStyle?: CustomFormStyleConfig['fieldGroup'];
}
export const FieldGroup = t0 => {
  const $ = _c(39);
  let children;
  let className;
  let customStyle;
  let errorMessage;
  let htmlFor;
  let label;
  let length;
  let maxLength;
  let message;
  let rest;
  let secondaryLabel;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== t0) {
    ({
      className,
      label,
      secondaryLabel,
      htmlFor,
      errorMessage,
      message,
      inputType: t1,
      children,
      length,
      maxLength,
      customStyle,
      required: t2,
      error: t3,
      showMaxLength: t4,
      theme: t5,
      disabled: t6,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = customStyle;
    $[4] = errorMessage;
    $[5] = htmlFor;
    $[6] = label;
    $[7] = length;
    $[8] = maxLength;
    $[9] = message;
    $[10] = rest;
    $[11] = secondaryLabel;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    children = $[1];
    className = $[2];
    customStyle = $[3];
    errorMessage = $[4];
    htmlFor = $[5];
    label = $[6];
    length = $[7];
    maxLength = $[8];
    message = $[9];
    rest = $[10];
    secondaryLabel = $[11];
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
  }
  const inputType = t1 === undefined ? "input" : t1;
  const required = t2 === undefined ? false : t2;
  const error = t3 === undefined ? false : t3;
  const showMaxLength = t4 === undefined ? false : t4;
  const theme = t5 === undefined ? "light" : t5;
  const disabled = t6 === undefined ? false : t6;
  const canDisplayMaxLength = length !== undefined && maxLength !== undefined && maxLength > 0 && showMaxLength;
  const canDisplayMessage = message?.length || errorMessage?.length || canDisplayMaxLength;
  const hasLabelOrMessage = inputType !== "control" || !!label || !!canDisplayMaxLength;
  const Component = inputType === "control" ? "fieldset" : "div";
  let t7;
  if ($[18] !== Component || $[19] !== canDisplayMaxLength || $[20] !== canDisplayMessage || $[21] !== children || $[22] !== className || $[23] !== customStyle || $[24] !== disabled || $[25] !== error || $[26] !== errorMessage || $[27] !== hasLabelOrMessage || $[28] !== htmlFor || $[29] !== inputType || $[30] !== label || $[31] !== length || $[32] !== maxLength || $[33] !== message || $[34] !== required || $[35] !== rest || $[36] !== secondaryLabel || $[37] !== theme) {
    t7 = hasLabelOrMessage ? <Component {...rest} className={cn("space-y-2", {
      "pointer-events-none": disabled
    }, className)}>{!!label && <FieldGroupLabel inputType={inputType} htmlFor={htmlFor} label={label} secondaryLabel={secondaryLabel} required={required} theme={theme} customStyle={customStyle} />}{children}{!!canDisplayMessage && <FieldGroupMessage message={error ? errorMessage : message} error={!!error} length={length} maxLength={maxLength} showMaxLength={canDisplayMaxLength} theme={theme} customStyle={customStyle} />}</Component> : children;
    $[18] = Component;
    $[19] = canDisplayMaxLength;
    $[20] = canDisplayMessage;
    $[21] = children;
    $[22] = className;
    $[23] = customStyle;
    $[24] = disabled;
    $[25] = error;
    $[26] = errorMessage;
    $[27] = hasLabelOrMessage;
    $[28] = htmlFor;
    $[29] = inputType;
    $[30] = label;
    $[31] = length;
    $[32] = maxLength;
    $[33] = message;
    $[34] = required;
    $[35] = rest;
    $[36] = secondaryLabel;
    $[37] = theme;
    $[38] = t7;
  } else {
    t7 = $[38];
  }
  return t7;
};